import { defineAsyncComponent } from 'vue'
export default {
  "seminar-lp": defineAsyncComponent(() => import("/app/src/layouts/SeminarLp.vue").then(m => m.default || m)),
  "seminar-lp-for1-column": defineAsyncComponent(() => import("/app/src/layouts/SeminarLpFor1Column.vue").then(m => m.default || m))
}